<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} {{aLang.ns_title}}</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} {{aLang.ns_title}}</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} {{aLang.ns_title}}</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="12">
              <el-form-item :label="aLang.ns_title_label" prop="tieu_de">
                <el-input
                  type="text"
                  v-model="mData.dataForm.tieu_de"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>

            <b-col md="4">
              <el-form-item :label="aLang.ns_language" prop="ngon_ngu">
                <el-select
                  v-model="mData.dataForm.ngon_ngu"
                  :placeholder="aLang.c_select"
                  @change="fn_changeNgonNgu(mData.dataForm.ngon_ngu)"
                  clearable
                  filterable
                  :disabled="mData.viewMode != 'create'"
                >
                  <el-option
                    v-for="item in mData.dataDefault.listLanguage"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>

            <b-col md="4">
              <el-form-item :label="aLang.ns_news_category" prop="danh_muc_id">
                <el-select
                  v-model="mData.dataForm.danh_muc_id"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  :clearable="false"
                  filterable
                  @change="fn_changeDanhMuc(mData.dataForm.danh_muc_id)"
                >
                  <el-option
                    v-for="item in mData.dataDefault.listDanhMucTinTuc"
                    :key="item.id"
                    :label="item.ten"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>

            <b-col md="4">
              <el-form-item :label="aLang.ns_display_object" prop="doi_tuong_hien_thi">
                <el-select
                  v-model="mData.dataForm.doi_tuong_hien_thi"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  multiple
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listDoiTuongHienThi"
                    :key="item.code"
                    :label="item.text"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>

            <b-col md="4">
              <el-form-item label=" " prop="an_bai_viet">
                <el-checkbox
                  v-model="mData.dataForm.an_bai_viet"
                  :disabled="mData.viewMode == 'detail'"
                >Ẩn bài viết</el-checkbox>
              </el-form-item>
            </b-col>

            <b-col md="4">
              <el-form-item
                :label="aLang.ns_timer"
                prop="thoi_diem_dang_bai"
              >
                <el-date-picker
                  type="datetime"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  v-model="mData.dataForm.thoi_diem_dang_bai"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                  :clearable="false"
                  :disabled="mData.viewMode == 'detail'"
                ></el-date-picker>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Tags" prop="tags">
                <el-select
                  v-model="mData.dataForm.tags"
                  :disabled="mData.viewMode == 'detail'"
                  multiple
                  filterable
                  allow-create
                  default-first-option
                  placeholder="Thêm tag cho bài viết"
                  no-data-text="Nhấn Enter để thêm tag"
                >
                    <el-option
                      v-for="item in mData.dataDefault.tagList"
                      :disabled="mData.viewMode == 'detail'"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <el-form-item :label="aLang.ns_content" prop="noi_dung">
                <editor-component
                  :prop-data-editor="mData.dataForm"
                  :prop-data-editor-key="'noi_dung'"
                  :prop-data-editor-disabled="mData.viewMode == 'detail'"
                ></editor-component>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  {{aLang.ns_news_image}}
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseAnh
                      v-b-tooltip.hover
                      :title="aLang.c_toggle"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseAnh" visible>
                  <b-row class="mb-2">
                    <b-col md="4">
                      <el-form-item class="mb-0" :label="aLang.ns_avatar" prop="anh.anh_dai_dien">
                        <el-upload
                          action
                          :auto-upload="false"
                          list-type="picture-card"
                          :limit="mData.fileUploadOption.AnhDaiDien.limit"
                          :accept="mData.fileUploadOption.AnhDaiDien.accept"
                          :on-change="fn_uploadChangeAnhDaiDien"
                          :on-preview="fn_uploadPreviewAnhDaiDien"
                          :on-remove="fn_uploadRemoveAnhDaiDien"
                          :on-exceed="fn_uploadExceedAnhDaiDien"
                          :file-list="mData.fileUploadOption.AnhDaiDien.fileList"
                          :disabled="mData.viewMode == 'detail'"
                          ref="anhDaiDien"
                          :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog
                          :close-on-click-modal="true"
                          :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                          width="60%"
                          top="51px"
                          title="Chi tiết"
                        >
                          <img
                            width="100%"
                            :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl"
                            alt
                          />
                        </el-dialog>
                      </el-form-item>
                    </b-col>
                    <b-col md="8">
                      <el-form-item class="mb-0" :label="aLang.ns_news_image" prop="anh.anh_tin_tuc">
                        <el-upload
                          action
                          :auto-upload="false"
                          list-type="picture-card"
                          :limit="mData.fileUploadOption.AnhTinTuc.limit"
                          :accept="mData.fileUploadOption.AnhTinTuc.accept"
                          :on-change="fn_uploadChangeAnhTinTuc"
                          :on-preview="fn_uploadPreviewAnhTinTuc"
                          :on-remove="fn_uploadRemoveAnhTinTuc"
                          :on-exceed="fn_uploadExceedAnhTinTuc"
                          multiple
                          ref="anhTinTuc"
                          :file-list="mData.fileUploadOption.AnhTinTuc.fileList"
                          :disabled="mData.viewMode == 'detail'"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog
                          :close-on-click-modal="true"
                          :visible.sync="mData.fileUploadOption.AnhTinTuc.dialogVisible"
                          width="60%"
                          top="51px"
                          title="Chi tiết"
                        >
                          <img
                            width="100%"
                            :src="mData.fileUploadOption.AnhTinTuc.dialogImageUrl"
                            alt
                          />
                        </el-dialog>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>
        <!-- Địa điểm -->
          <b-row class="mt-2" v-if="!isPhanAnh">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  {{aLang.ns_place}}
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseDiadiem
                      v-b-tooltip.hover
                      :title="aLang.c_toggle"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseDiadiem" visible>
                  <b-row>
                    <b-col md="6">
                      <el-form-item :label="aLang.ns_place" prop="dia_diem.dia_diem">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.dia_diem.dia_diem"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>

                    <b-col md="3">
                      <el-form-item :label="aLang.ns_province" prop=".dia_diem.province_id">
                        <el-select
                          v-model="mData.dataForm.dia_diem.province_id"
                          :placeholder="aLang.c_select"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listProvince"
                            :key="item.id"
                            :label="item.type + ' ' + item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="12">
                      <el-checkbox
                        v-model="mData.dataDefault.showMap"
                        :disabled="mData.viewMode == 'detail'"
                      >{{aLang.ns_location_on_the_map}}</el-checkbox>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <mapbox-component
                        :viewMode="mData.viewMode"
                        :config="mData.config"
                        @update="fn_getDataFromMapboxComponent"
                        :cordinatesValue="mData.mapDataObject.value"
                        :prop-disabled="mData.viewMode == 'detail'"
                        v-if="mData.dataDefault.showMap"
                        id="mapBox"
                      ></mapbox-component>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import ProvinceApi from "../../../moduleApi/ProvinceApi";
import DistrictApi from "../../../moduleApi/DistrictApi";
import DanhMucTinTucApi from "../../../moduleApi/DanhMucTinTucApi";
import TinTucModel from "./TinTucModel";
import TinTucApi from "../../../moduleApi/TinTucApi";
import MapboxComponent from '@/component/MapboxComponent';
import MapComponent from "../../../component/MapComponent";
import EditorComponent from "../../../component/EditorComponent";
import ValidService from '../../../service/ValidService';

export default {
  components: {
    MapComponent,
    EditorComponent,
    MapboxComponent
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "TinTuc",
        isPhanAnh: false,
        dataDefault: {
          roles: DataService.rolesInForm,
          listProvince: [],
          listDistrict: [],
          listKhachDuLich: [],
          listHuongDanVien: [],
          listCongTyLuHanh: [],
          listTour: [],
          listDanhMucTinTuc: [],
          listDoiTuongHienThi: DataService.doiTuongHienThi,
          listLanguage: DataService.Languages,
          searchMap: "",
          showMap: false,
          tagList: []
        },
        dataForm: MethodService.copyObject(TinTucModel.dataForm),
        validForm: TinTucModel.validForm,
        dialog: {},
        fileUploadOption: MethodService.copyObject(
          TinTucModel.dataFormOther.fileUploadOption
        ),
        dataPropMap: {
          fn_addLatLng: this.fn_addLatLng,
          lat: "",
          lng: "",
          id: "MapDiaDiem",
          reload: 0
        },
        mapDataObject: {
          value: [105.850176,21.0287797],
          geoJson: {
            type: "",
            coordinates: [],
          },
        },
        config:{
          type:"",
          viewMode:""
        }
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      if(this.mData.dataForm.tieu_de){
        this.mData.dataForm.tieu_de = this.mData.dataForm.tieu_de.trim();
      }

      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);
          if (data.noi_dung) {
            //replace http để lấy id ảnh
            data.noi_dung = MethodService.replaceURLImage(data.noi_dung);
          }
          if (!this.mData.dataDefault.showMap) {
            data.dia_diem.lat = null;
            data.dia_diem.lng = null;
          }else{
            data.dia_diem.lng = this.mData.mapDataObject.value[0];
            data.dia_diem.lat = this.mData.mapDataObject.value[1];
          }
          if (data.an_bai_viet == null) {
            data.an_bai_viet = false;
          }
          if (type == "create") {
            await TinTucApi.create(data);
            this.fn_resetForm();
          }
          if (type == "update") {
            data.id = this.$router.currentRoute.params.id;
            await TinTucApi.update(data);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(TinTucModel.dataForm);
      this.mData.dataForm.noi_dung = "";
      this.mData.fileUploadOption = MethodService.copyObject(
        TinTucModel.dataFormOther.fileUploadOption
      );
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await TinTucApi.findById(id);
      // debugger
      if (res.result.anh && res.result.anh.anh_dai_dien) {
        let data = {
          id: res.result.anh.anh_dai_dien,
          name: res.result.anh.anh_dai_dien,
          url: ExtensionService.urlImg + res.result.anh.anh_dai_dien
        };
        this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
      }
      if (res.result.anh && res.result.anh.anh_tin_tuc) {
        var data = [];
        for (let i = 0; i < res.result.anh.anh_tin_tuc.length; i++) {
          let item = {
            id: res.result.anh.anh_tin_tuc[i],
            name: res.result.anh.anh_tin_tuc[i],
            url: ExtensionService.urlImg + res.result.anh.anh_tin_tuc[i]
          };
          data.push(item);
        }

        this.mData.fileUploadOption.AnhTinTuc.fileList = data;
      }
      if (res.result.noi_dung) {
        res.result.noi_dung = MethodService.unreplaceURLImage(
          res.result.noi_dung
        );
      }
      if (
        res.result.dia_diem &&
        res.result.dia_diem.lat &&
        res.result.dia_diem.lng
      ) {
        this.mData.mapDataObject.value[0] = res.result.dia_diem.lng;
        this.mData.mapDataObject.value[1] = res.result.dia_diem.lat;
        this.mData.dataDefault.showMap = true;
      }
      this.mData.dataForm = res.result;
      let reqDanhMucTinTucApi = DanhMucTinTucApi.list({
        filters: "ngon_ngu=" + this.mData.dataForm.ngon_ngu,
        limit: 1000
      });
      let resDanhMucTinTucApi = await reqDanhMucTinTucApi;
      this.mData.dataDefault.listDanhMucTinTuc = resDanhMucTinTucApi.result;
    },
    async fn_initDataDefault() {
      let reqProvinceApi = ProvinceApi.list({ limit: 1000 });
      let reqDanhMucTinTucApi = DanhMucTinTucApi.list({ limit: 1000 });

      let resProvinceApi = await reqProvinceApi;
      let resDanhMucTinTucApi = await reqDanhMucTinTucApi;

      this.mData.dataDefault.listProvince = resProvinceApi.result;
      this.mData.dataDefault.listDanhMucTinTuc = resDanhMucTinTucApi.result;
    },

    async fn_changeNgonNgu(ngon_ngu_id) {
      let reqDanhMucTinTucApi = DanhMucTinTucApi.list({
        filters: "ngon_ngu=" + ngon_ngu_id,
        limit: 1000
      });
      let resDanhMucTinTucApi = await reqDanhMucTinTucApi;
      this.mData.dataDefault.listDanhMucTinTuc = resDanhMucTinTucApi.result;
      this.mData.dataForm.danh_muc_id = null;
    },
    async fn_changeDanhMuc(danhMucId) {
      let checkDanhMuc = this.mData.dataDefault.listDanhMucTinTuc.find(e => e.id == danhMucId);
      if (checkDanhMuc && checkDanhMuc.ten && checkDanhMuc.ten == "Phản ánh") {
        this.mData.dataDefault.listDoiTuongHienThi = [
          {
          code: "tourist",
          text: "App khách du lịch"
          }
        ];
        if (this.mData.dataForm.doi_tuong_hien_thi == "tourguide") {
          this.mData.dataForm.doi_tuong_hien_thi = undefined;
        }
        this.isPhanAnh = true;
        this.mData.validForm.anh = {
          anh_dai_dien: [ValidService.requiredChangeImage],
          anh_tin_tuc: [ValidService.requiredChangeImage]
        }
      } else {
        this.mData.dataDefault.listDoiTuongHienThi = [{
            code: "tourist",
            text: "App khách du lịch"
          },
          {
            code: "tourguide",
            text: "App hướng dẫn viên"
          }
        ]
        this.isPhanAnh = false;
        this.mData.validForm.anh = {
          anh_dai_dien: [],
          anh_tin_tuc: []
        }
      }
    },

    async fn_selectDistrict(pro_id) {
      let reqDistrictApi = DistrictApi.list({
        filters: "provinceId=" + pro_id,
        limit: 1000
      });
      let resDistrictApi = await reqDistrictApi;
      this.mData.dataForm.dia_diem.district_id = null;
      this.mData.dataDefault.listDistrict = resDistrictApi.result;
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    //upload ảnh
    fn_uploadCheckFileSize(file) {
      return MethodService.checkFileSize(file, 3);
    },

    fn_uploadRemoveAnhDaiDien(file, fileList) {
      this.mData.dataForm.anh.anh_dai_dien = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "tinTuc")
        .then(res => {
          this.mData.dataForm.anh.anh_dai_dien = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
          this.$refs['myForm'].fields.find((f) => f.prop == "anh.anh_dai_dien").clearValidate()
        })
        .catch(error => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },

    fn_uploadRemoveAnhTinTuc(file, fileList) {
      let data = [];
      $.each(fileList, (i, el) => {
        data.push(el.id);
      });
      this.mData.dataForm.anh.anh_tin_tuc = data;
    },
    fn_uploadChangeAnhTinTuc(file, fileList) {
      ExtensionService.upload(file, "tinTuc")
        .then(res => {
          this.mData.dataForm.anh.anh_tin_tuc.push(res.result);
          this.$refs['myForm'].fields.find((f) => f.prop == "anh.anh_tin_tuc").clearValidate()
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          this.mData.fileUploadOption.AnhTinTuc.fileList = fileList;
        })
        .catch(error => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhTinTuc(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhTinTuc.limit} file`
      );
    },
    fn_uploadPreviewAnhTinTuc(file) {
      this.mData.fileUploadOption.AnhTinTuc.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhTinTuc.dialogVisible = true;
    },
    fn_addLatLng(lat, lng) {
      this.mData.dataForm.dia_diem.lat = lat;
      this.mData.dataForm.dia_diem.lng = lng;
    },
    fn_getDataFromMapboxComponent(value) {
      // console.log(value);
      this.mData.mapDataObject = value;
    },
  },
  created: function() {
    this.fn_initDataDefault();

    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {}
};
</script>
<style scoped>
</style>